module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/placement.a1117be5.svg";